{
    "NAVIGATION_INFO_MANUAL": "Handbuch {{source}}"
}